import { Link, Typography } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { COAST_VOICE_PHONE } from '../../../../env';
import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { Loading } from '../../../../general/components/loading';
import { TerminalWizardPage } from '../../../../general/components/wizard-page';
import { RootState } from '../../../../store';
import { ReviewIcon } from '../../../../theme/coast/icons';

const selector = ({ nextStep: { loading } }: RootState) => ({
  loading,
});

const ApplicationOfflineReviewPage: FC = () => {
  const { loading } = useSelector(selector);
  return (
    <TerminalWizardPage
      icon={<ReviewIcon />}
      title="Check back soon!"
      subtext={<>We are reviewing your application.</>}
      footer={<YouCanComeBackNote />}
    >
      <Loading open={loading} />
      <Typography variant="inherit" align="center" color="textSecondary">
        There is one more step before your application is finalized. We&apos;ll email you within a day or two when
        it&apos;s time to continue. Have questions? Give us a call at{' '}
        <Link href={`tel:${COAST_VOICE_PHONE}`}>{COAST_VOICE_PHONE}</Link>.
      </Typography>
    </TerminalWizardPage>
  );
};

export { ApplicationOfflineReviewPage };
